import * as yup from 'yup'

export const showFormFieldError = (error?: yup.ValidationError, value?: string, errorState?: string, text?: string) => {
  // if validation error, and user input value is the same as the value that led to validation error
  // OR
  // if server error, and user input value is the same as the value that led to error
  return (!!error && error.params?.originalValue === value) || (errorState === 'true' && text === value)
}
